module.exports = __webpack_public_path__ + "img/play_btn.b7829c9e.svg";